export default __webpack_public_path__ + "static/media/hm.5b393cb4.svg";